import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './TabNavigation.css';

interface Tab {
  path: string;
  label: string;
  icon?: string;
}

interface TabNavigationProps {
  tabs: Tab[];
  basePath: string;
}

const TabNavigation: React.FC<TabNavigationProps> = ({ tabs, basePath }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === basePath) {
      return location.pathname === basePath || location.pathname === `${basePath}/`;
    }
    return location.pathname.startsWith(path);
  };

  const handleTabClick = (path: string) => {
    navigate(path);
  };

  return (
    <div className="tab-navigation">
      {tabs.map((tab) => (
        <button
          key={tab.path}
          className={`tab-item ${isActive(tab.path) ? 'active' : ''}`}
          onClick={() => handleTabClick(tab.path)}
        >
          {tab.icon && <span className="tab-icon">{tab.icon}</span>}
          <span className="tab-label">{tab.label}</span>
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;

